import React, { useEffect, useState } from "react";
import { getFirestore, doc, onSnapshot, updateDoc } from "firebase/firestore";
import { getStorage, ref, deleteObject } from "firebase/storage";
import { deleteField } from "firebase/firestore";

const DeleteFile = ({ selectedPatient, onClose }) => {
  const [files, setFiles] = useState({});
  const [selectedFile, setSelectedFile] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedFileText, setSelectedFileText] = useState("");

  useEffect(() => {
    if (!selectedPatient) return;

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatient.id);

    const unsubscribe = onSnapshot(
      patientRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setFiles(data.files || {});
        } else {
          setFiles({});
          setError("No hay archivos registrados para esta persona.");
        }
      },
      () => {
        setError("Ocurrió un error al cargar los archivos.");
      }
    );

    return () => unsubscribe();
  }, [selectedPatient]);

  const handleDelete = async () => {
    if (!selectedFile) {
      setError("Elige un archivo para eliminar.");
      return;
    }

    try {
      const db = getFirestore();
      const storage = getStorage();
      const patientRef = doc(db, "registeredPatients", selectedPatient.id);

      const fileRef = ref(
        storage,
        `patientFiles/${selectedPatient.id}/${selectedFile}`
      );
      await deleteObject(fileRef);

      const updatedFiles = { ...files };
      delete updatedFiles[selectedFile];

      if (Object.keys(updatedFiles).length === 0) {
        await updateDoc(patientRef, { files: deleteField() });
      } else {
        await updateDoc(patientRef, { files: updatedFiles });
      }

      setSuccess(`El archivo se eliminó correctamente.`);
      setSelectedFile("");
      setConfirmDelete(false);
    } catch (error) {
      console.error(error);
      setError("Ocurrió un error al eliminar el archivo.");
    }
  };

  const handleSelectFile = (e) => {
    const selectedKey = e.target.value;
    setSelectedFile(selectedKey);

    if (selectedKey && files[selectedKey]) {
      const fileData = files[selectedKey];
      const label = `${new Date(fileData.uploadedAt).toLocaleString()} - ${
        fileData.originalName
      }`;

      const shortText =
        label.length > 50 ? label.substring(0, 50) + "..." : label;

      setSelectedFileText(shortText);
    } else {
      setSelectedFileText("");
    }
  };

  return (
    <div className="deleteFileContainer">
      <h3>Eliminar Archivo</h3>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      {!confirmDelete ? (
        <>
          <select
            className="generalFormInput"
            value={selectedFile}
            onChange={handleSelectFile}
            style={{
              width: "100%",
              marginBottom: "10px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <option value="">Selecciona un archivo</option>
            {Object.entries(files)
              .sort(
                (a, b) => new Date(b[1].uploadedAt) - new Date(a[1].uploadedAt)
              )
              .map(([uniqueFileName, fileData]) => {
                const label = `${new Date(
                  fileData.uploadedAt
                ).toLocaleString()} - ${fileData.originalName}`;

                return (
                  <option
                    key={uniqueFileName}
                    value={uniqueFileName}
                    title={label}
                  >
                    {label.length > 50 ? label.substring(0, 50) + "..." : label}
                  </option>
                );
              })}
          </select>
          <button
            onClick={() => setConfirmDelete(true)}
            disabled={!selectedFile}
          >
            Eliminar
          </button>
        </>
      ) : (
        <div className="confirmationBox">
          <p>¿Confirmas que deseas eliminar el archivo "{selectedFileText}"?</p>
          <button onClick={handleDelete} className="confirmButton">
            Sí
          </button>
          <button
            onClick={() => setConfirmDelete(false)}
            className="cancelButton"
          >
            No
          </button>
        </div>
      )}
    </div>
  );
};

export default DeleteFile;
